<template>
  <v-container
    style="height: 100vh; padding: 0; z-index: 10000; overflow-y: auto"
  >
    <v-subheader
      class="title-header-card-item-component mb-4"
      v-text="
        tableId ? $t('checkout.orderToTable') : $t('checkout.selected_items')
      "
    />
    <div style="z-index: 1000">
      <div v-for="(item, index) in productsInCart" :key="item.id">
        <v-list-item class="test_blue">
          <v-list-item-content @click="showAction = -1">
            <v-container fluid pa-0 ma-0>
              <v-row no-gutters justify="space-between" align="center">
                <v-col>
                  <div>
                    <v-text-field
                      class="product-name pr-0 pr-sm-3 p-name"
                      style="font-weight: 700"
                      v-text="
                        item.productName +
                        `${
                          item.productVariationName
                            ? ' ( ' + item.productVariationName + ' )'
                            : ''
                        }`
                      "
                    />
                  </div>
                  <!-- Pickup date information for cart items -->
                  <div
                    v-if="item.productRequiredPickupDateFrom"
                    class="py-1 mt-1"
                  >
                    <v-chip color="info" x-small class="mr-1">
                      <v-icon x-small left>mdi-calendar-range</v-icon>
                      Pickup:
                      {{ formatDate(item.productRequiredPickupDateFrom) }} -
                      {{ formatDate(item.productRequiredPickupDateTo) }}
                    </v-chip>
                  </div>
                </v-col>
              </v-row>
              <v-col no-gutters style="padding-left: 0">
                <GroupedAddonsList
                  :grouped-addons="item.groupedAddons"
                  :format-money="$appFormatters.formatMoney"
                />
                <div class="py-1">
                  <span
                    v-if="item.productDiscount"
                    class="product-variation old-price pr-5"
                    v-text="$appFormatters.formatMoney(item.productSubTotal)"
                  />
                  <h3
                    class="!product-name active"
                    v-text="$appFormatters.formatMoney(item.itemTotalPrice)"
                  />
                </div>
                <!--              <v-col cols="8" class="test_yellow">-->
                <!--                <div v-if="item.addons.length > 0">-->
                <!--                  <p-->
                <!--                    v-for="addon in item.addons"-->
                <!--                    :key="addon.id"-->
                <!--                    class="product-addons-list"-->
                <!--                    style="margin-bottom: 8px"-->
                <!--                    v-text="-->
                <!--                      addon.quantity +-->
                <!--                      ' X ' +-->
                <!--                      addon.addonName +-->
                <!--                      ' (' +-->
                <!--                      $appFormatters.formatMoney(addon.addonTotalPrice) +-->
                <!--                      ')'-->
                <!--                    "-->
                <!--                  />-->
                <!--                </div>-->
                <!--              </v-col>-->
              </v-col>
            </v-container>
          </v-list-item-content>

          <v-list-item-action
            class="d-flex flex-column align-end mt-n2"
            style="position: absolute; right: 4px; top: 30px"
          >
            <v-row
              v-if="showAction !== index"
              no-gutters
              justify="end"
              class="test_blue mr-2"
            >
              <v-chip
                class="mb-2"
                color="light-grey"
                label
                text-color="primary"
                pill
                outlined
                style="font-size: 16px; font-weight: bold"
                @click="showAction = index"
              >
                {{ item.quantity }}
              </v-chip>
            </v-row>
            <QuantitySelector
              v-if="showAction === index"
              class="mr-2"
              :quantity="item.quantity"
              :min="1"
              @decrement="decrementItem(item.id)"
              @increment="incrementItem(item.id, item.quantity)"
            />
          </v-list-item-action>
        </v-list-item>
        <v-divider
          v-if="index < productsInCart.length - 1"
          class="mb-2 ml-4 mr-4"
        />
      </div>
      <div v-if="$vuetify.breakpoint.mobile" style="height: 400px" />
      <div v-if="!$vuetify.breakpoint.mobile" style="height: 200px" />
    </div>
    <v-row
      v-if="$store.getters.cartDetails && tableId"
      no-gutters
      align="start"
      justify="center"
      class="test_blue fill-height ma-0 pa-0"
    >
      <v-row no-gutters class="mt-5 ma-0 pa-0">
        <OrderDetails is-table-order="true" />
      </v-row>
    </v-row>
    <div class="checkout-btn-container">
      <v-expansion-panels v-if="tableId" focusable>
        <v-item class="my-1">
          <v-container>
            <CardItemsExpandComponents
              :is-ready="!$store.getters.isLoading"
              :active="!!comments"
            >
              <template v-slot:icon>
                <v-icon v-text="'mdi-phone'" />
              </template>
              <template v-slot:body>
                <v-col cols="12">
                  <span
                    class="title-card-item-component"
                    v-text="$t('inputs.phone_number')"
                  />
                </v-col>
              </template>
              <template v-slot:expantion>
                <v-container fluid fill-height pt-5>
                  <v-row no-gutters>
                    <vue-tel-input-vuetify
                      ref="phoneReister"
                      v-model="phone"
                      style="width: 100%"
                      :default-country="country"
                      type="tel"
                      :input-options="{
                        showDialCode: true,
                        tabindex: 0,
                      }"
                      mode="international"
                      :rules="[
                        $rules.required,
                        $rules.phoneNumber(phoneRegisterValid),
                      ]"
                      :valid-characters-only="true"
                      @input="onInputRegisterLogin"
                    />
                  </v-row>
                </v-container>
              </template>
            </CardItemsExpandComponents>
          </v-container>
        </v-item>
      </v-expansion-panels>
      <v-expansion-panels focusable style="background-color: #ffffff">
        <v-container>
          <v-item class="my-1">
            <CardItemsExpandComponents
              :is-ready="!$store.getters.isLoading"
              :active="!!comments"
            >
              <template v-slot:icon>
                <v-icon v-text="'mdi-message-outline'" />
              </template>
              <template v-slot:body>
                <v-col cols="12">
                  <span
                    class="title-card-item-component"
                    v-text="$t('checkout.comment_restaurant')"
                  />
                </v-col>
              </template>
              <template v-slot:expantion>
                <v-container fluid fill-height pt-5>
                  <v-row no-gutters>
                    <v-textarea
                      v-model="comments"
                      filled
                      clearable
                      :label="$t('inputs.comment')"
                      counter
                      maxlength="255"
                    />
                  </v-row>
                </v-container>
              </template>
            </CardItemsExpandComponents>
          </v-item>
        </v-container>
      </v-expansion-panels>
      <v-fab-transition>
        <v-container style="background-color: #ffffff">
          <v-btn
            :loading="isLoading"
            x-large
            color="primary"
            elevation="0"
            block
            class="btn"
            @click="onPressCheckout"
          >
            <v-icon v-text="'mdi-cart-minus'" />
            <span
              class="btn-checkout-text pr-10"
              v-text="tableId ? $t('checkout.confirmOrder') : 'Checkout'"
            />
            <span
              v-if="$store.getters.cartDetails?.subTotal"
              class="btn-checkout-total"
              v-text="
                $appFormatters.formatMoney($store.getters.cartDetails?.subTotal)
              "
            />
          </v-btn>
        </v-container>
      </v-fab-transition>
    </div>
  </v-container>
</template>

<script>
import OrderDetails from "@/views/front/checkout/components/subcomponent/OrderDetails.vue";
import QuantitySelector from "@/views/front/checkout/components/QuantitySelector.vue";
import { GroupedAddonsList } from "@/views/front/discovery/components/subcomponents";

export default {
  name: "CartDrawer",
  components: {
    OrderDetails,
    QuantitySelector,
    GroupedAddonsList,
  },
  data: () => ({
    totalItems: null,
    productsInCart: [],
    comments: null,
    phone: null,
    tableId: null,
    phoneRegisterValid: false,
    country: "DK",
    isLoading: false,
    showAction: -1,
  }),
  watch: {
    comments: function () {
      this.$emit("input", this.comments);
      const self = this;
      self.$store.dispatch("checkout/setComment", this.comments);
    },
    "$store.getters.cartDetails": function () {
      if (this.$store.getters.cartDetails) {
        this.totalItems = this.$store.getters.cartDetails.totalItems;
        this.productsInCart = this.$store.getters.cartDetails.items;
        this.$checkoutValidator.minOrderAmount();
      }
    },
    "$store.getters.checkoutComment": function () {
      this.comments = this.$store.getters.checkoutComment;
    },
  },
  beforeMount() {
    console.log("before mount", this.$route.params.tableId);
    if (this.$route.params.tableId) {
      this.$store.dispatch("cart/setLoadTableOrder");
    } else {
      this.$store.dispatch("cart/setLoad");
    }
  },
  created() {
    this.comments = this.$store.getters.checkoutComment;
  },
  mounted() {
    this.tableId = this.$route.params.tableId;
  },
  methods: {
    onInputRegisterLogin(formattedNumber, { valid }) {
      this.phoneRegisterValid = valid;
    },
    onPressCheckout: function () {
      if (this.tableId === undefined) {
        this.$router.push({
          name: "Checkout",
          params: { tableId: this.tableId },
        });
      } else {
        console.log("hi");
        this.isLoading = true;
        axios
          .post("/app/orders/checkout/tableOrder", {
            store_id: this.$store.getters.storeInfo.id,
            session_id: this.$store.getters.guestSessionId,
            phone: this.phone?.replace(/\s/g, ""),
            table_id: this.tableId,
            comments: this.comments,
          })
          .then((res) => {
            console.log(res);
            if (res.data.status === "Success") {
              this.$router.push({
                name: "ThanksQuick",
                params: {
                  orderref: res.data.data.order_ref,
                  tableId: this.tableId,
                },
              });
              Toast.fire({
                icon: "success",
                title: res.data.message,
              });
            } else {
              Swal.fire({
                icon: "error",
                title: this.$t("errors.error_alert_title"),
                text: res.data.data.message,
                reverseButtons: true,
                confirmButtonText: "ok",
              });
            }
          })
          .catch((e) => {
            Swal.fire({
              icon: "error",
              title: this.$t("errors.error_alert_title"),
              text: e.message,
              reverseButtons: true,
              confirmButtonText: "ok",
            });
          })
          .finally(() => (this.isLoading = false));
      }
    },
    addonsList: function (addosn) {
      let list = [];
      addosn.map((item) => {
        list.push(item.addonName);
      });
      return list.toString();
    },
    decrementItem: async function (id) {
      const self = this;
      self.$store.dispatch("loading/start");
      const { data } = await axios.delete(
        "/app/orders/shopping/cart/" + self.$store.getters.guestSessionId,
        {
          params: {
            itemQty: 1,
            itemId: id,
          },
        }
      );
      Toast.fire({
        icon: "success",
        title: data.message,
      });

      if (this.tableId) {
        self.$store.dispatch("cart/setLoadTableOrder");
      } else {
        self.$store.dispatch("cart/setLoad");
      }
      if (data.data.totalItems <= 0) {
        self.$store.dispatch("guest/removeSessionId");
        self.$store.dispatch("checkout/setTotal", 0);
        this.$emit("close");
        setTimeout(() => {
          this.$router.push({ name: "Discovery" });
        }, 200);
      }

      self.$store.dispatch("loading/done");
    },
    incrementItem: async function (id, qty) {
      const self = this;
      self.$store.dispatch("loading/start");
      const { data } = await axios.patch(
        "/app/orders/shopping/cart/" + self.$store.getters.guestSessionId,
        {
          itemQty: parseInt(qty) + 1,
          itemId: id,
        }
      );
      Toast.fire({
        icon: "success",
        title: data.message,
      });

      if (this.tableId) {
        self.$store.dispatch("cart/setLoadTableOrder");
      } else {
        self.$store.dispatch("cart/setLoad");
      }

      self.$store.dispatch("loading/done");
    },
    formatDate: function (dateString) {
      if (!dateString) return "";
      const date = new Date(dateString);
      return date.toLocaleDateString("da-DK", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      });
    },
  },
};
</script>

<style lang="scss">
.checkout-btn-container {
  position: fixed;
  bottom: 0;
  width: 100%;
}
.p-name {
  font-size: 1.12rem !important;
}
</style>
